(function () {
  document.querySelectorAll('.acc-ellaola-lp-01-sticky-bar').forEach(function (root) {
    var bar = root.querySelector('.acc-ellaola-lp-01-sticky-bar__bar');
    if (!bar) return;

    var cta = root.querySelector('.acc-ellaola-lp-01-sticky-bar__btn');
    var nowEl = root.querySelector('.acc-ellaola-lp-01-sticky-bar__price-now');
    var oldEl = root.querySelector('.acc-ellaola-lp-01-sticky-bar__price-old');

    function applyAge(detail) {
      if (!detail) return;
      if (nowEl) nowEl.textContent = detail.now || '';
      if (oldEl) {
        if (detail.old) {
          oldEl.textContent = detail.old;
          oldEl.hidden = false;
        } else {
          oldEl.textContent = '';
          oldEl.hidden = true;
        }
      }
    }

    function fromActiveTab() {
      var btn = document.querySelector('.acc-ellaola-lp-01-offer__age-btn.is-active');
      if (!btn) return;
      applyAge({
        now: btn.getAttribute('data-now') || '',
        old: btn.getAttribute('data-old') || ''
      });
    }

    function announceOffset() {
      var announce = document.querySelector('.acc-ellaola-lp-01-announce');
      if (!announce) return 0;
      var wrap = announce.closest('[id^="shopify-section-"]') || announce;
      var pos = window.getComputedStyle(wrap).position;
      if (pos !== 'sticky' && pos !== 'fixed') return 0;
      return wrap.getBoundingClientRect().height;
    }

    function scrollToOffer(e) {
      var offer = document.getElementById('acc-ellaola-lp-01-offer') || document.querySelector('.acc-ellaola-lp-01-offer');
      if (!offer) return;
      e.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var top = offer.getBoundingClientRect().top + window.pageYOffset - announceOffset();
      window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
    }

    if (cta) cta.addEventListener('click', scrollToOffer);

    fromActiveTab();
    document.addEventListener('acc-ellaola-lp-01:agechange', function (e) {
      applyAge(e.detail);
    });

    var trigger = document.querySelector('[data-acc-ellaola-lp-01-sticky-trigger]');
    var hider = document.querySelector('[data-acc-ellaola-lp-01-sticky-hide]');

    var pastTrigger = !trigger;
    var hiderVisible = false;

    function update() {
      var visible = pastTrigger && !hiderVisible;
      bar.classList.toggle('is-visible', visible);
      document.body.classList.toggle('acc-ellaola-lp-01-sticky-bar-visible', visible && bar.offsetHeight > 73);
    }

    window.addEventListener('resize', update);

    if ('IntersectionObserver' in window) {
      if (trigger) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          pastTrigger = e.isIntersecting || e.boundingClientRect.top < 0;
          update();
        }, { threshold: 0 }).observe(trigger);
      }
      if (hider) {
        new IntersectionObserver(function (entries) {
          hiderVisible = entries[0].isIntersecting;
          update();
        }, { threshold: 0 }).observe(hider);
      }
    } else {
      pastTrigger = true;
    }

    update();
  });
})();
